import PropTypes from 'prop-types';
import React from 'react';
import styles from './CollegeCornerOverview.scss';
import CollegeCornerOverviewData from './CollegeCornerOverviewData';

const activeRosterSortField = 'activeRoster.power6.power6Rating';
const schoolSortField = 'school.power6';
const genderValues = {
    FEMALE: 'F',
    MALE: 'M',
};

function CollegeCornerOverView({
    clubId,
    isLoggedIn,
    userIsProCollegeClubOwnerValue,
    handleLearnMoreUtrCollegeState,
    hideMaskedP6,
    isRostersRolloutEnabled,
}) {
    const power6SortField = isRostersRolloutEnabled
        ? activeRosterSortField
        : schoolSortField;

    const power6SortParam = encodeURIComponent(`${power6SortField}:desc`);

    // API Endpoints
    const collegeTeamsApi = (gender) => `/colleges?top=5&skip=0&utrType=verified&utrTeamType=singles&schoolClubSearch=true&sort=${power6SortParam}&searchOrigin=searchPage&gender=${gender}`;
    const collegePlayersApi = (gender) => `/players?top=5&skip=0&gender=${gender}&utrType=verified&utrTeamType=singles&sort=singlesUtr%3Adesc&searchOrigin=searchPage&primaryTags=College`;
    const juniorsApi = (gender) => `/players?top=5&skip=0&gender=${gender}&utrType=verified&utrTeamType=singles&sort=singlesUtr%3Adesc&searchOrigin=searchPage&primaryTags=Junior&utrReliability=rated&ageMin=12&ageMax=18`;

    return (
        <div className={`${styles.collegeCornerOverview} mt24`}>
            <div className={`${styles.flexbox}`}>
                <div>
                    <CollegeCornerOverviewData
                        type="colleges"
                        title="Top college Women's teams"
                        api={collegeTeamsApi(genderValues.FEMALE)}
                        viewAll="teams?gender=F"
                        clubId={clubId}
                        isLoggedIn={isLoggedIn}
                        userIsProCollegeClubOwnerValue={userIsProCollegeClubOwnerValue}
                        handleLearnMoreUtrCollegeState={handleLearnMoreUtrCollegeState}
                        hideMaskedP6={hideMaskedP6}
                        isRostersRolloutEnabled={isRostersRolloutEnabled}
                    />
                </div>

                <div>
                    <CollegeCornerOverviewData
                        type="colleges"
                        title="Top college Men's teams"
                        api={collegeTeamsApi(genderValues.MALE)}
                        viewAll="teams?gender=M"
                        clubId={clubId}
                        isLoggedIn={isLoggedIn}
                        userIsProCollegeClubOwnerValue={userIsProCollegeClubOwnerValue}
                        handleLearnMoreUtrCollegeState={handleLearnMoreUtrCollegeState}
                        hideMaskedP6={hideMaskedP6}
                        isRostersRolloutEnabled={isRostersRolloutEnabled}
                    />
                </div>
            </div>
            <div className={`${styles.flexbox}`}>
                <div>
                    <CollegeCornerOverviewData
                        type="profiles"
                        title="Top female players"
                        api={collegePlayersApi(genderValues.FEMALE)}
                        viewAll="players?gender=F"
                        clubId={clubId}
                        isLoggedIn={isLoggedIn}
                        userIsProCollegeClubOwnerValue={userIsProCollegeClubOwnerValue}
                        handleLearnMoreUtrCollegeState={handleLearnMoreUtrCollegeState}
                        hideMaskedP6={hideMaskedP6}
                    />
                </div>

                <div>
                    <CollegeCornerOverviewData
                        type="profiles"
                        title="Top male players"
                        api={collegePlayersApi(genderValues.MALE)}
                        viewAll="players?gender=M"
                        clubId={clubId}
                        isLoggedIn={isLoggedIn}
                        userIsProCollegeClubOwnerValue={userIsProCollegeClubOwnerValue}
                        handleLearnMoreUtrCollegeState={handleLearnMoreUtrCollegeState}
                        hideMaskedP6={hideMaskedP6}
                    />
                </div>
            </div>
            <div className={`${styles.divider}`} />
            <div className={`${styles.collegeCornerOverviewHeader}`}>Juniors</div>
            <div className={`${styles.flexbox}`}>
                <div>
                    <CollegeCornerOverviewData
                        type="profiles"
                        title="Top female juniors"
                        api={juniorsApi(genderValues.FEMALE)}
                        viewAll="juniors?gender=F"
                        clubId={clubId}
                        isLoggedIn={isLoggedIn}
                        userIsProCollegeClubOwnerValue={userIsProCollegeClubOwnerValue}
                        handleLearnMoreUtrCollegeState={handleLearnMoreUtrCollegeState}
                        hideMaskedP6={hideMaskedP6}
                    />
                </div>

                <div>
                    <CollegeCornerOverviewData
                        type="profiles"
                        title="Top male juniors"
                        api={juniorsApi(genderValues.MALE)}
                        viewAll="juniors?gender=M"
                        clubId={clubId}
                        isLoggedIn={isLoggedIn}
                        userIsProCollegeClubOwnerValue={userIsProCollegeClubOwnerValue}
                        handleLearnMoreUtrCollegeState={handleLearnMoreUtrCollegeState}
                        hideMaskedP6={hideMaskedP6}
                    />
                </div>
            </div>
        </div>
    );
}

CollegeCornerOverView.propTypes = {
    clubId: PropTypes.number,
    hideMaskedP6: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    userIsProCollegeClubOwnerValue: PropTypes.bool,
    handleLearnMoreUtrCollegeState: PropTypes.func,
    isRostersRolloutEnabled: PropTypes.bool,
};

CollegeCornerOverView.defaultProps = {
    clubId: null,
    hideMaskedP6: false,
    isLoggedIn: false,
    userIsProCollegeClubOwnerValue: false,
    handleLearnMoreUtrCollegeState: () => { },
    isRostersRolloutEnabled: false,
};

export default CollegeCornerOverView;
